import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2, ShoppingCart, ArrowRight } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
export function AddedToCartModal() {
  const {
    isAddedModalOpen,
    closeAddedModal,
    lastAddedProduct,
    openCart
  } = useCartStore();
  if (!lastAddedProduct) return null;
  return <AnimatePresence data-id="element-10">
      {isAddedModalOpen && <>
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none" data-id="element-11">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeAddedModal} className="fixed inset-0 bg-brand-blueDark/60 backdrop-blur-sm pointer-events-auto" data-id="element-12" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col pointer-events-auto relative z-10" data-id="element-13">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-14">
                <div className="flex items-center gap-2 text-green-600" data-id="element-15">
                  <CheckCircle2 className="w-6 h-6" data-id="element-16" />
                  <h2 className="text-xl font-black" data-id="element-17">Додано в кошик</h2>
                </div>
                <button onClick={closeAddedModal} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-18">
                  <X className="w-6 h-6 text-gray-500" data-id="element-19" />
                </button>
              </div>

              <div className="p-6" data-id="element-20">
                <div className="flex items-center gap-4 mb-8" data-id="element-21">
                  <img src={lastAddedProduct.img} alt={lastAddedProduct.title} className="w-20 h-20 object-cover rounded-xl border border-gray-200" data-id="element-22" />
                  <div data-id="element-23">
                    <h3 className="font-bold text-brand-blue text-lg leading-tight mb-1" data-id="element-24">
                      {lastAddedProduct.title}
                    </h3>
                    <p className="text-brand-muted font-medium" data-id="element-25">
                      {lastAddedProduct.price} грн
                    </p>
                  </div>
                </div>

                <div className="flex flex-col gap-3" data-id="element-26">
                  <button onClick={openCart} className="w-full py-4 bg-brand-yellow hover:bg-brand-yellowHover text-brand-blueDark rounded-xl font-black text-lg shadow-button transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2" data-id="element-27">
                    <ShoppingCart className="w-5 h-5" data-id="element-28" />
                    Оформити замовлення
                  </button>
                  <button onClick={closeAddedModal} className="w-full py-4 bg-gray-100 hover:bg-gray-200 text-brand-blue rounded-xl font-bold text-lg transition-all flex items-center justify-center gap-2" data-id="element-29">
                    Продовжити покупки
                    <ArrowRight className="w-5 h-5" data-id="element-30" />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}